import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_IFRAME_MODAL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_IFRAME_MODAL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/IframeModal')
};